import { useCallback, useEffect, useRef, useState } from "react";
import { api, WS_DISPLAY_URL } from "@/lib/clinic";

// Schermo sala: riceve solo i codici chiamati, nessun dato personale del paziente.
export function useDisplayQueue() {
  const [current, setCurrent] = useState(null);
  const [connected, setConnected] = useState(false);
  const [lastEvent, setLastEvent] = useState(null);
  const wsRef = useRef(null);
  const retryRef = useRef(null);

  const refetch = useCallback(async () => {
    const { data } = await api.get("/display/state");
    setCurrent(data.current || null);
  }, []);

  useEffect(() => {
    let closed = false;

    const connect = () => {
      if (closed) return;
      const ws = new WebSocket(WS_DISPLAY_URL);
      wsRef.current = ws;

      ws.onopen = () => setConnected(true);
      ws.onmessage = (e) => {
        const msg = JSON.parse(e.data);
        if (msg.current) setCurrent(msg.current);
        setLastEvent({ type: msg.type, payload: msg.payload, at: Date.now() });
      };
      ws.onclose = () => {
        setConnected(false);
        if (!closed) retryRef.current = setTimeout(connect, 2000);
      };
      ws.onerror = () => ws.close();
    };

    refetch().catch(() => {});
    connect();

    return () => {
      closed = true;
      clearTimeout(retryRef.current);
      wsRef.current?.close();
    };
  }, [refetch]);

  return { current, connected, lastEvent };
}
